import React, { useState, forwardRef } from "react";
import PropTypes from "prop-types";

const Button = forwardRef(
  (
    {
      label,
      icon,
      color,
      hoverColor,
      widthLength,
      fontSize,
      size,
      onClick,
      shape,
      title,
      padding,
      justifyContent,
      style, // Custom inline styles
      disabled, // Disable the button
      iconColor,  // Add iconColor prop
      labelColor, // Add labelColor prop
    },
    ref
  ) => {
    const [isHovered, setIsHovered] = useState(false);

    const buttonStyle = {
      // backgroundColor: isHovered ? hoverColor || color : color,
      backgroundColor: "black",
      color: "white",
      width: shape === "circle" ? size : widthLength,
      height: size,
      padding: padding || (shape === "circle" ? "0" : `${size / 4}px ${size / 3}px`),
      fontSize: fontSize || size / 3.5,
      borderRadius: shape === "circle" ? "50%": shape === "oval" ? "30px" : shape === "rounded" ? "20%" : "5px",
      border: "none",
      cursor: disabled ? "not-allowed" : "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: justifyContent,
      gap: "10px",
      transition: "background-color 0.2s ease, transform 0.2s ease",
      transform: isHovered && !disabled ? "scale(1.1)" : "scale(1)",
      opacity: disabled ? 0.6 : 1, // Dim button when disabled
      ...style,
    };

    const iconStyle = {
      fontSize: (fontSize || size / 3.5) * 1.5,
      color: iconColor || "black", // Use iconColor prop
    };

    const labelStyle = {
      fontSize: fontSize || size / 3.5,
      lineHeight: 1,
      color: "Black",
    };

    return (
      <span
        ref={ref}
        style={buttonStyle}
        onClick={!disabled ? onClick : undefined}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        title={title || label || "button"}
        aria-label={title || label || "button"} // Accessibility
      >
        {icon && <span style={iconStyle}>{icon}</span>}
        {label && <span style={labelStyle}>{label}</span>}
      </span>
    );
  }
);

Button.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.element,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  widthLength: PropTypes.number,
  size: PropTypes.number,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
  shape: PropTypes.oneOf(["circle", "oval", "rect"]),
  title: PropTypes.string,
  padding: PropTypes.string,
  justifyContent: PropTypes.oneOf([
    "center",
    "flex-start",
    "flex-end",
    "space-between",
    "space-around",
    "space-evenly",
    "stretch",
    "unset",
  ]),
  style: PropTypes.object,
  disabled: PropTypes.bool, // New prop
  iconColor: PropTypes.string, // New prop for icon color
  labelColor: PropTypes.string, // New prop for label color
};

Button.defaultProps = {
  label: "",
  icon: null,
  color: "#363133",
  hoverColor: "#232223",
  size: 40,
  widthLength: 100,
  fontSize: null,
  onClick: () => {},
  shape: "circle",
  title: "",
  padding: "",
  justifyContent: "center",
  style: {},
  disabled: false, // Default to enabled
  iconColor: "black", // Default icon color
  labelColor: "black", // Default label color
};

export default Button;
